import { create } from "zustand";

interface VerifyCheckboxStore {
  isVerified: boolean;
  setIsVerified: (value: boolean) => void;
}

export const useVerifyCheckboxStore = create<VerifyCheckboxStore>((set) => ({
  isVerified: false,
  setIsVerified: (value) => set({ isVerified: value }),
}));
